/**
 * Featured-event designation contract (U6 / R18–R21).
 *
 * The designation is a school-level pointer to ONE event, so setting it is a
 * single write that replaces whatever was there — a school can never resolve
 * two heroes. The event named here is validated server-side against the
 * acting school before the pointer moves (R19); a cross-school id is refused,
 * not silently ignored.
 */

import { z } from 'zod'

export const SetFeaturedTicketedEventRequestSchema = z.object({
  // Public CUID of the event to feature. Validated against the acting school.
  eventPublicId: z.string().min(1)
})
export type SetFeaturedTicketedEventRequest = z.infer<typeof SetFeaturedTicketedEventRequestSchema>

/**
 * Response for both set and clear. `featuredEventId` is null after a clear, and
 * after a set is the id that now holds the designation — echoed back so the UI
 * reflects committed state rather than what it optimistically sent.
 */
export const FeaturedTicketedEventResponseSchema = z.object({
  featuredEventId: z.string().nullable()
})
export type FeaturedTicketedEventResponse = z.infer<typeof FeaturedTicketedEventResponseSchema>
